"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DAYS_ENABLED_SELECTOR = exports.DAYS_VISIBLE_SELECTOR = exports.DAYS_SELECTOR = void 0;
exports.DAYS_SELECTOR = '.tk-daypicker-day--outside, .tk-daypicker-day';
exports.DAYS_VISIBLE_SELECTOR = '.tk-daypicker-day';
exports.DAYS_ENABLED_SELECTOR = '.tk-daypicker-day:not(.tk-daypicker-day--disabled)';
